import React, { useState } from "react";
import {
  Input,
  Button,
  Form,
  DatePicker,
  Typography,
  message,
  Select,
} from "antd";
import { post } from "../../api/axios";
import { useNavigate } from "react-router-dom";

const { Title } = Typography;
const { Option } = Select;

const PlatformCouponsCreate = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);

    const payload = {
      code: values.code,
      night: values.night,
      days: values.days, // ✅ جديد
      start_date: values.start_date.format("YYYY-MM-DD"),
      end_date: values.end_date.format("YYYY-MM-DD"),
    };

    post("makan-coupons", payload)
      .then(() => {
        message.success("تم الإضافة بنجاح");
        navigate("/platform-coupons");
      })
      .catch((err) => {
        message.error(err.response?.data?.message || "خطأ");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div>
      <Title level={2}>إضافة كوبون</Title>

      <Form onFinish={onFinish} layout="vertical">
        <Form.Item name="code" label="الكود" rules={[{ required: true }]}>
          <Input />
        </Form.Item>

        <Form.Item name="night" label="نسبة الخصم" rules={[{ required: true }]}>
          <Input type="number" />
        </Form.Item>

        {/* ✅ days */}
        <Form.Item name="days" label="عدد الأيام" rules={[{ required: true }]}>
          <Select placeholder="اختر عدد الأيام">
            {[...Array(10)].map((_, i) => (
              <Option key={i + 1} value={i + 1}>
                {i + 1}
              </Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="start_date"
          label="تاريخ البداية"
          rules={[{ required: true }]}
        >
          <DatePicker className="w-100" />
        </Form.Item>

        <Form.Item
          name="end_date"
          label="تاريخ النهاية"
          rules={[{ required: true }]}
        >
          <DatePicker className="w-100" />
        </Form.Item>

        <Button type="primary" htmlType="submit" loading={loading} block>
          إضافة
        </Button>
      </Form>
    </div>
  );
};

export default PlatformCouponsCreate;
